import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgS25LogoRound = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 300,
	height: 300,
	viewBox: "0 0 300 300",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 300,
			height: 300,
			fill: "#000cb5",
			rx: 150
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m85.2 143.8-13.4-3.3q-6-1.4-8.5-3.8a9 9 0 0 1-2.5-6.9 10 10 0 0 1 3.4-7.9q3.4-3 9.7-3 6.8 0 10.4 3.7 2 2 3 4.5h19.4a29 29 0 0 0-10-16.6q-8.2-6.7-22.3-6.7-9.5 0-16.8 3.3a26 26 0 0 0-11.2 9.5q-4 6-4 14.3 0 11.1 6 17.2t17.3 8.6L79 160q5.4 1.3 7.7 3.8a10 10 0 0 1 2.2 6.7q0 5-3.7 7.8-3.8 3-10.2 3-7.4 0-11.4-3.6a19 19 0 0 1-5.7-10l-18.4 2.8a29 29 0 0 0 11.1 19.4 40 40 0 0 0 23.7 6.4q15 0 24-7t9-19.7q0-11-5.5-17t-16.7-8.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff8fff",
			d: "m139.3 165.9 26.2-7.9a26.4 26.4 0 0 0-8.7-51.4l-38.4.1v21.4h39.1a4.7 4.7 0 0 1 1.1 9.3l-40.2 12v46.8h63.5v-21.5h-42.6zm76.5-28.9 26.3 7.8a26.4 26.4 0 0 1-8.7 51.4l-38.5-.1v-21.4H234a4.7 4.7 0 0 0 1-9.3l-40.2-12v-46.7h63.5V128h-42.6z"
		})
	]
});
export default SvgS25LogoRound;
